export default [
    {
        path: 'dict/list',
        name: 'sys_manage_dict_list',
        meta: { isCache: true, icon: 'md-pin', hideInMenu: false },
        component: () => import('@/views/sys_manage/dict/dict-list.vue'),
    },
    {
        path: 'dict/add',
        name: 'sys_manage_dict_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/sys_manage/dict/dict-add.vue'),
    },
    {
        path: 'dict/edit/:id',
        name: 'sys_manage_dict_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/sys_manage/dict/dict-edit.vue'),
    },
    {
        path: 'dict/detail/:id',
        name: 'sys_manage_dict_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/sys_manage/dict/dict-detail.vue'),
    },
];
